unit unit_EinzelBeleg;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Grids, strutils, XData.Web.Client, DB;

type
  TEinzelBeleg = class(TForm)
    xdsBeleg: TXDataWebDataSet;
    TC: TTableControl;
    PTC: TTableControl;
    xdsPositionen: TXDataWebDataSet;
    WClient: TXDataWebClient;
    btnPDF: TButton;
    btnZurueck: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure xdsBelegAfterOpen(DataSet: TDataSet);
    procedure xdsPositionenAfterOpen(DataSet: TDataSet);
    procedure btnPDFClick(Sender: TObject);
    procedure btnZurueckClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    Belegnummer:string;
    Belegart:string;

  protected procedure LoadDFMValues; override; end;

var
  EinzelBeleg: TEinzelBeleg;
  Einkauf:boolean;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TEinzelBeleg.btnPDFClick(Sender: TObject);
  procedure OnResponse(Response:TXDataClientResponse);
  var
    mydownload:string;
  begin
    mydownload:=string(TJSObject(response.Result)['value']);
    if mydownload='WRONG' then
    begin
      showmessage('Download kann nicht bereitgestellt werden');
    end
    else
    begin
      application.Navigate(downloadconnection+mydownload,ntblank);
    end;
  end;
begin
  if LizenzOK then
  begin
    WClient.RawInvoke('IServerService.BelegPDF',[Belegnummer],@OnResponse);
  end
  else
  begin
    showmessage('Für das Abrufen von Dateien sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
  end;

end;

procedure TEinzelBeleg.btnZurueckClick(Sender: TObject);
begin
  self.Close;
end;

procedure TEinzelBeleg.WebFormShow(Sender: TObject);
begin
  if Belegart='Angebote' then xdsbeleg.EntitySetName:='Angebote';
  if Belegart='Aufträge' then xdsbeleg.EntitySetName:='Auftrag';
  if Belegart='Lieferscheine' then xdsbeleg.EntitySetName:='Lieferschein';
  if Belegart='Rechnungen' then xdsbeleg.EntitySetName:='Rechnung';
  if Belegart='Anfragen' then xdsbeleg.EntitySetName:='Anfrage';
  if Belegart='Bestellungen' then xdsbeleg.EntitySetName:='Bestellung';
  if Belegart='Wareneingänge' then xdsbeleg.EntitySetName:='Wareneingang';
  if Belegart='EingangsRechnungen' then xdsbeleg.EntitySetName:='EingangsRE';

  if Belegart='Angebote' then Einkauf:=false;
  if Belegart='Aufträge' then Einkauf:=false;
  if Belegart='Lieferscheine' then Einkauf:=false;
  if Belegart='Rechnungen' then Einkauf:=false;
  if Belegart='Anfragen' then Einkauf:=true;
  if Belegart='Bestellungen' then Einkauf:=true;
  if Belegart='Wareneingänge' then Einkauf:=true;
  if Belegart='EingangsRechnungen' then Einkauf:=true;

  xdsBeleg.QueryString:='$expand=Kundennummer&$filter=Nummerkomplett eq '+QuotedStr(Belegnummer);
  xdsBeleg.Load;
end;

procedure TEinzelBeleg.xdsBelegAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
begin
  TC.RowCount:=10;
  TC.Cells[0,0]:='<h4>Einzel-Beleg';
  myelement:=TC.cellelements[0,1];
  btnzurueck.ParentElement:=myelement;
  btnpdf.ParentElement:=myelement;
  //btnzurueck.Align:=alleft;
  //btnpdf.Align:=alLeft;
  TC.Cells[0,2]:='<b>Bezeichnung';
  TC.Cells[1,2]:='<b>Wert';
  if Belegart='Angebote' then TC.Cells[0,3]:='Angebot | Datum';
  if Belegart='Aufträge' then TC.Cells[0,3]:='Auftrag | Datum';
  if Belegart='Lieferscheine' then TC.Cells[0,3]:='Lieferschein | Datum';
  if Belegart='Rechnungen' then TC.Cells[0,3]:='Rechnung | Datum';
  if Belegart='Anfragen' then TC.Cells[0,3]:='Anfrage | Datum';
  if Belegart='Bestellungen' then TC.Cells[0,3]:='Bestellung | Datum';
  if Belegart='Wareneingänge' then TC.Cells[0,3]:='Wareneingang | Datum';
  if Belegart='EingangsRechnungen' then TC.Cells[0,3]:='Eingangsrechnung | Datum';
  TC.Cells[1,3]:='<h5>'+xdsbeleg.FieldByName('Nummerkomplett').asstring +' | '+formatdatetime('DD.MM.YYYY',xdsbeleg.FieldByName('Datum').asdatetime);

  TC.Cells[0,4]:='Kontaktnummer';
  TC.Cells[1,4]:='<h6>'+xdsBeleg.FieldByName('Kundennummer.Kundennummer').asstring;

  TC.Cells[0,5]:='Anschrift';
  TC.Cells[1,5]:='<h6>'+ReplaceStr(xdsbeleg.FieldByName('Adressebild').asstring,#13+#10,'<BR>');

  TC.Cells[0,6]:='Auftragsbezeichnung';
  TC.Cells[1,6]:='<h6>'+xdsBeleg.FieldByName('Auftragsbezeichnung').asstring;

  TC.Cells[0,7]:='Objektnummer';
  TC.Cells[1,7]:='<h6>'+xdsBeleg.FieldByName('Objektnummer').asstring;

  TC.Cells[0,8]:='Lieferanschrift';
  try
  TC.Cells[1,8]:='<h6>'+ReplaceStr(xdsbeleg.FieldByName('Lieferanschriftbild').asstring,#13+#10,'<BR>');
  except
  end;
  TC.Cells[0,9]:='Nettosumme';
  TC.Cells[1,9]:=formatfloat('#,##0.00',xdsbeleg.fieldbyname('Nettosumme').asfloat);

  xdspositionen.Close;
  if Belegart='Angebote' then xdsPositionen.EntitySetName:='PositionenAngebote';
  if Belegart='Aufträge' then xdsPositionen.EntitySetName:='PositionenAuftrag';
  if Belegart='Lieferscheine' then xdsPositionen.EntitySetName:='PositionenLieferschein';
  if Belegart='Rechnungen' then xdsPositionen.EntitySetName:='PositionenRechnung';
  if Belegart='Anfragen' then xdsPositionen.EntitySetName:='PositionenAnfrage';
  if Belegart='Bestellungen' then xdsPositionen.EntitySetName:='PositionenBestellung';
  if Belegart='Wareneingänge' then xdsPositionen.EntitySetName:='PositionenWareneingang';
  if Belegart='EingangsRechnungen' then xdsPositionen.EntitySetName:='PositionenEingangsRE';
  xdsPositionen.QueryString:='$expand=Artikelnummer&$filter=Nummerkomplett eq '+QuotedStr(Belegnummer)+'&$orderby=PosNr';
  xdsPositionen.Load;
end;

procedure TEinzelBeleg.xdsPositionenAfterOpen(DataSet: TDataSet);
var
  I: Integer;
begin
  PTC.RowCount:=xdsPositionen.RecordCount+1;
  PTC.ColCount:=8;
  PTC.Cells[0,0]:='PosNr';
  PTC.Cells[1,0]:='PosUNr';
  PTC.Cells[2,0]:='Artikelnummer';
  PTC.Cells[3,0]:='Artikelüberschrift';
  PTC.Cells[4,0]:='Beschreibung';
  PTC.Cells[5,0]:='Menge';
  PTC.Cells[6,0]:='Einzel-VKP';
  if Einkauf then PTC.Cells[6,0]:='Einzel-EKP';
  PTC.Cells[7,0]:='Endpreis';

  xdspositionen.First;
  for I := 1 to xdspositionen.RecordCount do
  begin
    PTC.Cells[0,i]:=xdspositionen.FieldByName('PosNr').AsString;
    PTC.Cells[1,i]:=xdspositionen.FieldByName('PosUNr').AsString;
    PTC.Cells[2,i]:=xdspositionen.FieldByName('Artikelnummer.Artikelnummer').AsString;
    PTC.Cells[3,i]:=xdspositionen.FieldByName('Artikelueberschrift').AsString;
    PTC.Cells[4,i]:=xdspositionen.FieldByName('Artikelbeschreibung').AsString;
    PTC.Cells[5,i]:='<p class="text-right">'+xdspositionen.FieldByName('Menge').AsString;
    if not einkauf then PTC.Cells[6,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPositionen.fieldbyname('Verkaufspreis').asfloat);
    if einkauf then PTC.Cells[6,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPositionen.fieldbyname('Einkaufspreis').asfloat);
    if not einkauf then PTC.Cells[7,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPositionen.fieldbyname('Endpreis').asfloat);
    if einkauf then PTC.Cells[7,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsPositionen.fieldbyname('Endpreis').asfloat);



    xdspositionen.Next;
  end;
end;

procedure TEinzelBeleg.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  PTC := TTableControl.Create(Self);
  btnPDF := TButton.Create(Self);
  btnZurueck := TButton.Create(Self);
  xdsBeleg := TXDataWebDataSet.Create(Self);
  xdsPositionen := TXDataWebDataSet.Create(Self);
  WClient := TXDataWebClient.Create(Self);

  TC.BeforeLoadDFMValues;
  PTC.BeforeLoadDFMValues;
  btnPDF.BeforeLoadDFMValues;
  btnZurueck.BeforeLoadDFMValues;
  xdsBeleg.BeforeLoadDFMValues;
  xdsPositionen.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  try
    Name := 'EinzelBeleg';
    Width := 364;
    Height := 480;
    Caption := 'EinzelBeleg';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.AlignWithMargins := True;
    TC.Left := 3;
    TC.Top := 3;
    TC.Width := 358;
    TC.Height := 220;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.Align := alClient;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.Options.ScrollVertical := True;
    TC.WordWrap := True;
    TC.ColCount := 2;
    PTC.SetParentComponent(Self);
    PTC.Name := 'PTC';
    PTC.AlignWithMargins := True;
    PTC.Left := 3;
    PTC.Top := 229;
    PTC.Width := 358;
    PTC.Height := 248;
    PTC.ElementClassName := 'table table-hover table-bordered table-striped';
    PTC.Align := alBottom;
    PTC.BorderColor := clSilver;
    PTC.ChildOrder := 2;
    PTC.ColHeader := False;
    PTC.ElementHeaderClassName := 'table-info';
    PTC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    PTC.Options.ScrollVertical := True;
    PTC.WordWrap := True;
    PTC.ColCount := 2;
    btnPDF.SetParentComponent(Self);
    btnPDF.Name := 'btnPDF';
    btnPDF.AlignWithMargins := True;
    btnPDF.Left := 105;
    btnPDF.Top := 3;
    btnPDF.Width := 96;
    btnPDF.Height := 54;
    btnPDF.Caption := 'Download-PDF';
    btnPDF.ChildOrder := 1;
    btnPDF.ElementClassName := 'btn btn-info text-left mr-1';
    btnPDF.ElementFont := efCSS;
    btnPDF.ElementPosition := epIgnore;
    btnPDF.HeightStyle := ssAuto;
    btnPDF.HeightPercent := 100.000000000000000000;
    btnPDF.WidthStyle := ssAuto;
    btnPDF.WidthPercent := 100.000000000000000000;
    SetEvent(btnPDF, Self, 'OnClick', 'btnPDFClick');
    btnZurueck.SetParentComponent(Self);
    btnZurueck.Name := 'btnZurueck';
    btnZurueck.AlignWithMargins := True;
    btnZurueck.Left := 11;
    btnZurueck.Top := 3;
    btnZurueck.Width := 96;
    btnZurueck.Height := 54;
    btnZurueck.Caption := 'zur'#252'ck';
    btnZurueck.ChildOrder := 1;
    btnZurueck.ElementClassName := 'btn btn-info text-left mr-1';
    btnZurueck.ElementFont := efCSS;
    btnZurueck.ElementPosition := epIgnore;
    btnZurueck.HeightStyle := ssAuto;
    btnZurueck.HeightPercent := 100.000000000000000000;
    btnZurueck.WidthStyle := ssAuto;
    btnZurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnZurueck, Self, 'OnClick', 'btnZurueckClick');
    xdsBeleg.SetParentComponent(Self);
    xdsBeleg.Name := 'xdsBeleg';
    xdsBeleg.AfterOpen := xdsBelegAfterOpen;
    xdsBeleg.EntitySetName := 'Angebote';
    xdsBeleg.Connection := DM2.XDataWebConnection1;
    xdsBeleg.SubpropsDepth := 1;
    xdsBeleg.QueryString := '$expand=Kundennummer';
    xdsBeleg.Left := 476;
    xdsBeleg.Top := 72;
    xdsPositionen.SetParentComponent(Self);
    xdsPositionen.Name := 'xdsPositionen';
    xdsPositionen.AfterOpen := xdsPositionenAfterOpen;
    xdsPositionen.EntitySetName := 'PositionenAnfrage';
    xdsPositionen.Connection := DM2.XDataWebConnection1;
    xdsPositionen.SubpropsDepth := 1;
    xdsPositionen.QueryString := '$expand=Artikelnummer';
    xdsPositionen.Left := 476;
    xdsPositionen.Top := 128;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 256;
    WClient.Top := 58;
  finally
    TC.AfterLoadDFMValues;
    PTC.AfterLoadDFMValues;
    btnPDF.AfterLoadDFMValues;
    btnZurueck.AfterLoadDFMValues;
    xdsBeleg.AfterLoadDFMValues;
    xdsPositionen.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
  end;
end;

end.